var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("h1", { staticClass: "page-title" }, [_vm._v(_vm._s(_vm.title))]),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            [
              _c(
                "b-form",
                {
                  staticClass: "search-block",
                  on: {
                    submit: function ($event) {
                      $event.preventDefault()
                    },
                  },
                },
                [
                  _c(
                    "b-form-group",
                    [
                      _c("b-form-input", {
                        attrs: { type: "text", placeholder: _vm.placeHolder },
                        on: {
                          keyup: function ($event) {
                            if (
                              !$event.type.indexOf("key") &&
                              _vm._k(
                                $event.keyCode,
                                "enter",
                                13,
                                $event.key,
                                "Enter"
                              )
                            )
                              return null
                            $event.preventDefault()
                            return _vm.handleOnClick.apply(null, arguments)
                          },
                        },
                        model: {
                          value: _vm.stringValue,
                          callback: function ($$v) {
                            _vm.stringValue = $$v
                          },
                          expression: "stringValue",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "b-button",
                    {
                      staticClass: "position-absolute",
                      attrs: { type: "button", variant: "link" },
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          return _vm.handleOnClick.apply(null, arguments)
                        },
                      },
                    },
                    [_vm._v("Buscar")]
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "b-col",
            { staticClass: "custom-btn-width" },
            [
              _c(
                "b-button",
                {
                  attrs: { block: "", type: "submit", variant: "secondary" },
                  on: { click: _vm.handleSearchClick },
                },
                [_vm._v(_vm._s(_vm.btnLabel))]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }